module.exports = __webpack_public_path__ + "static/img/APPC.d7d03502.png";